import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const accept = useCallback((data) => {
    localStorage.setItem("hs_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const login = async (email, password) => accept((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => accept((await api.post("/auth/register", body)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("hs_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
